module.exports = __webpack_public_path__ + "static/media/8OLA17.9c5cf607.jpg";